/**
 * @description 判断文件是否是文档类型
 * @param {String} type 文件类型
 */
export const getSuffixIsDocType = type => {
    return ['doc', 'docx', 'ppt', 'xlsx'].includes(type);
};
/**
 * @description 判断文件是否是图片类型
 * @param {String} type 文件类型
 */
export const getSuffixIsImageType = type => {
    return ['png', 'jpg', 'jpeg', 'gif'].includes(type);
};
/**
 * @description 下载附件
 * @param {String} name 文件名称
 * @param {String} url 文件路径
 */
export const downloadFile = (name, url) => {
    // const a = document.createElement('a');
    // a.href = url;
    // a.download = name;
    // a.target = '_blank';
    // a.click();
    window.location = url;
};